<template>
  <FlexLayout role="region">
    <BlockContainer>
      {{ landingErrorMessage }}
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import {useAppStore} from "@/stores/app";
import {Mode} from "@/constants/constants";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";

export default {
  components: {FlexLayout, BlockContainer},
  setup() {
    const appStore = useAppStore();

    return {
      appStore,
    };
  },
  props: {
    sessionTimeout: {
      type: Boolean,
    }
  },
  computed: {
    landingErrorMessage() {
      if (this.sessionTimeout) {
        if (this.appStore.isMode(Mode.TABLE) || this.appStore.isMode(Mode.TAKEAWAY)) {
          return this.$t('notification.landingSessionError');
        }
      }
      return this.$t('notification.landingGenericError');
    },
  },
};
</script>

<style scoped>
</style>
